import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withKeys as _withKeys, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = ["value"]
const _hoisted_2 = {
  key: 0,
  class: "absolute left-0 z-40 mt-2 overflow-y-auto border shadow-xl top-full custumScroll rounded-xl border-secondary bg-[#252b38]",
  style: {"width":"26rem","max-height":"60vh"}
}
const _hoisted_3 = {
  key: 0,
  class: "px-3 py-3 text-sm text-gray-400"
}
const _hoisted_4 = { class: "px-3 py-1 text-xs font-semibold tracking-wide text-gray-400 uppercase" }
const _hoisted_5 = ["onMousedown"]
const _hoisted_6 = { class: "text-accent" }
const _hoisted_7 = {
  key: 0,
  class: "text-xs text-gray-400"
}
const _hoisted_8 = {
  key: 0,
  class: "px-3 py-3 text-sm text-amber-400"
}

import { ref, computed } from "vue";
	import { useRouter } from "vue-router";
	import api from "@/api";
	import { useQuickSearch } from "@/composable/useQuickSearch";
	import { searchResultRoute } from "@/composable/searchResultRoute";

	/**
	 * Barre de recherche GLOBALE de l'application (header).
	 *
	 * Frappe → recherche multi-ressources débouncée (useQuickSearch) →
	 * menu déroulant de résultats groupés (Clients, Colis, Billets,
	 * Agences). Entrée ou « Voir tous les résultats » → page dédiée
	 * /workspace/recherche.
	 */
	
export default /*#__PURE__*/_defineComponent({
  __name: 'SearchBar',
  setup(__props) {

	const router = useRouter();
	const term = ref("");
	const open = ref(false);

	const {
		results: groups,
		loading,
		searched,
		search,
	} = useQuickSearch(async (q: string) => {
		const res: any = await api().search.global(`?search=${encodeURIComponent(q)}`);
		return res?.data?.groups ?? [];
	});

	const totalResults = computed(() =>
		(groups.value ?? []).reduce((n: number, g: any) => n + (g.items?.length ?? 0), 0),
	);

	const onType = (e: any) => {
		term.value = e?.target?.value ?? "";
		open.value = true;
		search(term.value);
	};

	const goToResults = () => {
		const q = term.value.trim();
		if (q.length < 2) return;
		open.value = false;
		router.push({ name: "workspace-recherche", query: { q } });
	};

	// Clic sur un résultat : route directe vers la vue détail.
	//  • colis  → panneau détail riche de son module (PackagesRegistration) ;
	//  • autres → page de recherche, panneau détail auto-ouvert (?t=&i=).
	const goToResult = (type: string, item: any) => {
		open.value = false;
		const target = searchResultRoute(type, item);
		if (target) {
			router.push(target);
			return;
		}
		router.push({
			name: "workspace-recherche",
			query: { q: term.value.trim(), t: type, i: item.id },
		});
	};

	// Léger délai après blur pour laisser le clic sur un item passer.
	const onFocusOut = () => setTimeout(() => (open.value = false), 180);

	const showDropdown = computed(() => open.value && term.value.trim().length >= 2);

return (_ctx: any,_cache: any) => {
  const _component_Icon = _resolveComponent("Icon")!

  return (_openBlock(), _createElementBlock("div", {
    class: "relative flex flex-row items-center space-x-2",
    onFocusout: onFocusOut
  }, [
    _createVNode(_component_Icon, {
      src: "/media/icons/search-icon.svg",
      css: "w-6 h-6",
      class: "opacity-50"
    }),
    _createElementVNode("input", {
      class: "bg-transparent rounded-fulll outline-none focus:outline-none autofill:bg-transparent",
      type: "text",
      placeholder: "Rechercher dans l'application…",
      value: term.value,
      onInput: onType,
      onFocus: _cache[0] || (_cache[0] = ($event: any) => (open.value = true)),
      onKeyup: _withKeys(goToResults, ["enter"])
    }, null, 40, _hoisted_1),
    (showDropdown.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_unref(loading))
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, "Recherche…"))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(groups), (group) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: group.type,
                    class: "py-1"
                  }, [
                    _createElementVNode("p", _hoisted_4, _toDisplayString(group.label), 1),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.items, (item) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: item.id,
                        class: "px-3 py-2 cursor-pointer hover:bg-[#374151]",
                        onMousedown: _withModifiers(($event: any) => (goToResult(group.type, item)), ["prevent"])
                      }, [
                        _createElementVNode("p", _hoisted_6, _toDisplayString(item.title), 1),
                        (item.subtitle)
                          ? (_openBlock(), _createElementBlock("p", _hoisted_7, _toDisplayString(item.subtitle), 1))
                          : _createCommentVNode("", true)
                      ], 40, _hoisted_5))
                    }), 128))
                  ]))
                }), 128)),
                (_unref(searched) && totalResults.value === 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_8, " Aucun résultat pour « " + _toDisplayString(term.value) + " ». ", 1))
                  : _createCommentVNode("", true),
                (totalResults.value > 0)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 1,
                      class: "px-3 py-2 text-sm border-t cursor-pointer border-[#374151] text-accent hover:bg-[#374151]",
                      onMousedown: _withModifiers(goToResults, ["prevent"])
                    }, " Voir tous les résultats → ", 32))
                  : _createCommentVNode("", true)
              ], 64))
        ]))
      : _createCommentVNode("", true)
  ], 32))
}
}

})